import { render, staticRenderFns } from "./SheetResult.vue?vue&type=template&id=1b9b70ec&scoped=true&lang=pug&"
import script from "./SheetResult.vue?vue&type=script&lang=ts&"
export * from "./SheetResult.vue?vue&type=script&lang=ts&"
import style0 from "./SheetResult.vue?vue&type=style&index=0&id=1b9b70ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9b70ec",
  null
  
)

component.options.__file = "SheetResult.vue"
export default component.exports